import { render, staticRenderFns } from "./PaymentTariffForm.vue?vue&type=template&id=d064486a&scoped=true&"
import script from "./PaymentTariffForm.vue?vue&type=script&lang=js&"
export * from "./PaymentTariffForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d064486a",
  null
  
)

export default component.exports